import api from '@/services/api';

import { type OKR } from '../type';

export const getOKRs = async () => {
  return await api.get<OKR[]>('okrs');
};
